import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd, { message } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

message.config({ maxCount: 1 })
import 'virtual:uno.css'
import '@/assets/styles/base.scss'

import App from './App.vue'
import { routerInit } from './router'

const app = createApp(App)
app.use(createPinia())
app.use(Antd)
app.use(routerInit(import.meta.env.BASE_URL))
app.mount('#app')
